import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSnd } from '../traitTypes/TraitTypeSnd';
import { TraitTypeSlotKey } from '../traitTypes/TraitTypeSlotKey';
export class TraitRegistryMediaSound extends TraitRegistryCategory {
    label = 'Sound';
    constructor(parent) {
        super(parent);
        super.init();
    }
    slot = () => new TraitTypeSlotKey({
        multiple: true,
        /*    label: 'Slot',
            icon: 'fa fa-square-o',
            aspectsTemplate: { core: ['slotCategory', 'slotFillDuty'] } */
    });
    sound = new TraitTypeSnd({
        /*   label: 'Audio',
           icon: 'far fa-file-audio', */
        multiple: true,
        css: () => [],
        key: 'sound',
        /* creates: ['mediaSequence'] as any, // , 'medseq'
         createTraits: ({ at }) => {
           if (!at.trait.value) return [];
     
           const medSeqTrait = runtime.class.Trait.fromSerialized({
             key: 'mediaSequence',
             traitGroup: at.trait.traitGroup,
             value: {
               type: 'medseq',
               mediumLabel: at.trait.value.mediumLabel,
               sequenceName: 'auto'
             }
           });
           medSeqTrait.isGenerated = true;
           return [medSeqTrait];
         } */
    });
}
